/* src/app/app.component.scss */
.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 25rem;
  max-width: 73.75rem;
  width: 100%;
  margin: 0 auto;
}
app-footer {
  border-top: 0.125rem solid var(--ods-color-gray-20);
  text-align: right;
  padding: 1.5rem;
  width: 73.75rem;
  margin: 0 auto;
}
.alert-message {
  position: fixed;
  top: 3rem;
  right: 5rem;
  width: 27rem;
  background: var(--white);
  border: 1px solid var(--neutral-20);
  padding: 1rem;
}
.alert-message.warn {
  background: var(--accent-2-30);
}
.alert-message.warn ods-icon {
  color: var(--accent-2-50);
}
.alert-message.error {
  background: var(--negative-2);
}
.alert-message.error ods-icon {
  color: var(--negative-3);
}
.alert-message .close {
  position: absolute;
  right: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
}
.alert-message .alert-message-content {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto;
  grid-auto-columns: auto;
}
.alert-message .alert-message-content h2 {
  font-size: 1rem;
}
.alert-message .alert-message-content h2 ods-icon {
  width: 3rem;
  height: 2rem;
}
/*# sourceMappingURL=app.component.css.map */
